module.exports = __webpack_public_path__ + "static/media/view-light.8cdb96f8.svg";